























import Vue from "vue";

export default Vue.extend({
  //after clicking on the button push the mealId to the end of the url path
  methods: {
    goToDetailPage(id: string): void {
      this.$router.push({ name: "details", params: { productId: id } });
    },
    // sort meals by name ,if names are the same sort by mealId as well
    sortMeals(): void {
      this.$store.state.mealsArray.sort((a, b) =>
        a.strMeal > b.strMeal
          ? 1
          : a.strMeal === b.strMeal
          ? a.idMeal > b.idMeal
            ? 1
            : -1
          : -1
      );
    },
  },
  // return homepage meals from the getter in the store
  computed: {
    HomeMeals() {
      return this.$store.getters.returnHomePageMeals;
    },
  },
  // before component is added to the DOM trigger action at the store and clear random page ingredients
  created(): void {
    this.$store.state.ingredients = [];
    this.$store.dispatch("fetchHomePageMeals");
  },
  //after the vue instance has been destroyed clear detail page ingredients
  destroyed() {
    this.$store.state.ingredients2 = [];
  },
});
